export * from './remitos-home';
export * from './common';
export * from './remitos-detail-page';
export * from './remitos-generar-page';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/index.ts